<template>
  <div class="main-info head-page">

    <div class="wrapper">
      <form @submit="onSubmit" class="left" @keypress.enter="save">
        <div class="title-container">
          <div class="title">
            <input
              :readonly="!editing"
              v-autowidth="{
                maxWidth: '500px'
              }"
              class="h-empty-input h-monrope"
              placeholder="Name"
              v-model="crop.name"
              type="text"
              onkeypress="return event.keyCode != 13;"
            >
          </div>
          <div class="type h-roboto">
            <template v-if="$store.getters['crop/base'].owner == 0">
              {{$ml.get(`SYSTEM`)}}
            </template>
            <template v-else>
              {{$ml.get(`USER-DEFINED`)}}
            </template>

          </div>
        </div>

        <!-- <div class="temperatures">
          <div class="min item">
            <div class="item-wrapper">
              <MinTemp/>
              <input
                class="h-empty-input h-monrope"
                v-model.number="base.minTemp"
                type="text"
                :readonly="!editing"
              >
            </div>
          </div>
          <div class="base item">
            <div class="item-wrapper">
              <BaseTemp/>
              <input
                class="h-empty-input h-monrope"
                v-model.number="base.baseTemp"
                type="text"
                :readonly="!editing"
              >
            </div>
          </div>
          <div class="max item">
            <div class="item-wrapper">
              <MaxTemp/>
              <input
                class="h-empty-input h-monrope"
                v-model.number="base.maxTemp"
                type="text"
                :readonly="!editing"
              >
            </div>
          </div>
        </div> -->

        <div class="actions">
          <template v-if="crop.owner != 0">
            <app-btn
              v-if="!editing"
              @click="del"
              :loading="loading"
              :danger="true"
              class="del"
              w-auto
            >
              {{$ml.get(`Delete`)}}
            </app-btn>
            <app-btn
              v-if="!editing"
              @click="editOn"
              class="create"
              w-auto
            >
              {{$ml.get(`edit`)}}
            </app-btn>
            <template v-else>
              <app-btn
                @click="save"
                :loading="loading"
                type="button"
                class="save"
                w-auto
              >
                {{$ml.get(`save`)}}
              </app-btn>
              <app-btn
                @click="editOff"
                type="button"
                styling="inline"
                w-auto
              >
                {{$ml.get(`cancel`)}}
              </app-btn>
            </template>
          </template>
        </div>
      </form>
      <template v-if="$store.getters['user/plan'] != 'impact'">
        <btn v-if="crop.owner == 0" 
        :loading="loading"
        @click="useAsBase">
          {{$ml.get(`use as base`)}}
        </btn>
      </template>
    </div>

  </div>
</template>

<script>
import API from '@/api'
import BaseTemp from "./icons/BaseTemp";
import MinTemp from "./icons/MinTemp";
import MaxTemp from "./icons/MaxTemp";
import { mapGetters } from 'vuex'

export default {

  components: {
    BaseTemp,
    MinTemp,
    MaxTemp,
  },

  data() {
    return {
      editing: false,
      loading: false,
    };
  },


  methods: {


    editOn() {
      this.editing = true;
      return false;
    },


    editOff() {
      this.editing = false;
      return false;
    },


    useAsBase() {
      this.loading = true;
      return API.crop.extendBaseCrop({
        baseCropId: this.crop.id,
        varietyId: this.variety.id,
        growingMethodId: this.growingMethod.id,
      })
      .then(res => {

        this.$store.dispatch('user-crops/updateData')
        this.$store.commit('crop/setSelectingBaseMode')
        this.$router.push(`/dashboard/crops/${res.data.data.id}`)
        this.$notify({
          group: 'notices',
          title: this.$ml.get('Base crop successfully extended'),
          type: 'success',
        });
        this.$store.commit('crop/cropbar/setSearch', this.crop.name);
      })
      .finally(() => {
        this.loading = false;
      });
    },


    onSubmit(e) {
      e.preventDefault();
      this.editing = false;
    },


    onUpload(file) {
      this.file = JSON.parse(file.target.response).id;
    },


    // create() {
    //   return API.crop.createBaseCrop(this.data).then(res => {
    //     this.$store.commit('crop/saveBase', res.data);
    //   }).finally(() => {

    //   });
    // },

    save() {
      this.loading=true;
      return API.crop.updateBaseCrop(this.crop.id, this.crop).then(res => {
        this.$store.dispatch('user-crops/updateData');
        this.$store.commit('crop/cropbar/setSearch', this.crop.name);
        this.$notify({
          group: 'notices',
          title: this.$ml.get('Saving completed'),
          text: 'Saving crop has been successfully',
          type: 'success',
        });
      })
      .finally(() => {
        this.loading=false;
      });
    },
    del() {
      this.loading=true;
      return API.crop.deleteUserCrop(this.crop.id)
      .then(res => {
        this.$store.dispatch('user-crops/updateData')
        .then(res=>{
          this.$router.push('/dashboard/crops');
        });
        this.$store.commit('crop/cropbar/setSearch', this.crop.name);
        this.$notify({
          group: 'notices',
          title: this.$ml.get('Deleting completed'),
          text: this.$ml.get('Deleting crop has been successfully'),
          type: 'success',
        });
      })
      .finally(() => {
        this.loading=false;
      });
    },
  },

  created() {

  },

  destroyed() {

  },

  computed: {
    ...mapGetters({
      crop: 'crop/base',
      variety: 'crop/variety',
      growingMethod: 'crop/method',
    })
  },
  watch: {
    // base.name
    'crop.name': function (val) {
      if (this.editing) {
        var temp = val.split(' ');
        for (var i in temp) {
          if (temp[i].length > 16) {
            temp[i] = temp[i].substring(0, temp[i].length - 1)
          }
        }
        val = temp.join(' ');
        this.crop.name = val;
      }

    }
  }
}
</script>

<style lang="scss" scoped>

.main-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  // height: 80px;
  width: 100%;

  .wrapper {
    height: 50px;
    width: 100%;
    padding-bottom: 10px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }

  .left {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    .actions {
      display: flex;
      flex-direction: row;
    }
    .title-container {
      position: relative;
      .title {
        color: #4C5056;
        font-weight: bold;

        input {
          color: #4C5056;
          font-size: 33px;
          font-weight: bold;
          border-bottom: 1px solid #4C5056;
          margin-right: 5px;
          height: 33px;
          transition: border-bottom 0.3s ease;

          &[readonly] {
            border-bottom: 1px solid transparent;
          }
        }
      }
      .type {
        white-space: nowrap;
        top: calc(100% + 2px);
        position: absolute;
        color: rgba(76, 80, 86, 0.65);
        font-size: 14px;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        font-weight: 600;
        display: flex;
        align-items: center;
      }
    }

    .temperatures {
      display: flex;
      flex-direction: row;
      align-items: flex-end;

      .item {
        display: flex;
        flex-direction: row;
        align-items: flex-end;

        padding: 0 5px;

        .item-wrapper {
          display: flex;
          flex-direction: row;
          align-items: center;

          svg {
            margin-right: 0px;
          }
        }

        &.max {
          padding-right: 15px;
        }

        input {
          font-size: 13px;
          color: #568129;
          width: 30px;
          border-bottom: 1px solid #568129;
          appearance: none;
          text-align: center;
          padding-bottom: 5px;
          padding-top: 5px;
          transition: border-bottom 0.3s ease;

          &[readonly] {
            border-bottom: 1px solid transparent;
          }
        }
      }
    }

    .save {
      margin-right: 10px;
    }
    .del{
      margin-right: 10px;
    }
  }
  @media(max-width:768px) {
    .wrapper {
      height: auto;
      flex-direction: column;
      align-items: flex-start;
      form.left {
        // padding-bottom: 32px;
        display: flex;
        flex-direction: row;
        flex-wrap:wrap;
        align-items: flex-start;
        .btn {
          flex-basis: calc(50% - 5px);
          margin-right: 5px;
        }

        .title-container {
          padding-bottom: 32px;
          flex-basis: 100%;
          .type {
            top:calc(100% - 30px);
          }
          .title {
            position: relative;
            input {
              width: 100%!important;
            }
          }
        }
      }
    }
  }
}

</style>
